var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-radio-group',_vm._b({attrs:{"text-color":_vm.radioButtonTextColor,"fill":_vm.radioButtonBackgroundColor},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'el-radio-group',_vm.trimAttrs(_vm.$attrs),false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }